import getWindow from './isWindow';
import offset from './offset';
export default function height(node, client) {
  var win = getWindow(node);
  return win ? win.innerHeight : client ? node.clientHeight : offset(node).height;
}


//////////////////
// WEBPACK FOOTER
// ../~/dom-helpers/esm/height.js
// module id = 2592
// module chunks = 121